const BACKEND = require(`/core${process.env.NODE_ENV === 'development' ? '.local' : ''}.json`)

export const API = BACKEND.LCCore.GraphQLAPIURL
export const API_KEY = BACKEND.LCCore.AppSyncAPIKey
